const breakpoints = {
  small: window.matchMedia("(min-width: 0px) and (max-width: 1023px)"),
  medium: window.matchMedia("(min-width: 1024px) and (max-width: 1619px)"),
  big: window.matchMedia("(min-width: 1620px)"),
};

export default breakpoints;



// WEBPACK FOOTER //
// ./scripts/util/breakpoints.js